module.exports = __webpack_public_path__ + "static/media/icon-star.a21d6578.svg";